<template>
  <main class="prizes">
    <img class="img_glow_left" src="/static/images/home/glow.png">
    <section>
      <h1>{{ getTranslations.visitor_prizes_prizes }}</h1>
      <p class="title_tag">{{ getTranslations.visitor_prizes_play }} <b>{{ getTranslations.visitor_prizes_big }}</b></p>

      <template v-if="prizeDisplayMode === displayModeEnum.SINGLE">
        <div class="box_prize col_monthly">
          <h3>{{ getTranslations.visitor_prizes_single_display_mode_title }}</h3>

          <p>{{ getTranslations.visitor_prizes_single_display_mode_description }}</p>

          <div class="prize_single_img">
            <prize-single-display-mode-image></prize-single-display-mode-image>
          </div>

          <p>{{ getTranslations.visitor_prizes_single_display_mode_reward }}</p>
        </div>
      </template>

      <template v-else-if="prizeDisplayMode === displayModeEnum.CAROUSEL">
        <div class="box_prize col_grand" v-if="prize1">
          <h3>{{ getTranslations.visitor_prizes_grand_prizes }}</h3>
          <p>{{ getTranslations.visitor_prizes_prizes_desc }}</p>
          <div class="img_placeholder">
            <p class="txt"><img :src="grandPrize.imgUrl || '/static/images/prize_images/prize-grand.png'"></p>
          </div>
          <p>{{ grandPrize.headline }}</p>
        </div>

        <div class="box_prize col_monthly" v-if="prize2">
          <h3>{{ getTranslations.visitor_prizes_monthly_prizes }}</h3>
          <p>{{ getTranslations.visitor_prizes_prizes_desc }}</p>
          <div class="img_placeholder">
            <p class="txt"><img :src="monthlyPrize.imgUrl || '/static/images/prize_images/prize-monthly.png'"></p>
          </div>
          <p>{{ monthlyPrize.headline }}</p>
        </div>

        <div class="box_prize col_weekly" v-if="prize3">
          <h3>{{ getTranslations.visitor_prizes_weekly_prizes }}</h3>
          <p>{{ getTranslations.visitor_prizes_prizes_desc }}</p>
          <div class="img_placeholder">
            <p class="txt"><img :src="weeklyPrize.imgUrl || '/static/images/prize_images/prize-weekly.png'"></p>
          </div>
          <p>{{ weeklyPrize.headline }}</p>
        </div>
      </template>

    </section>
  </main>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import 'owl.carousel';
import PrizeCarousel from './PrizeCarousel';
import Howtowin from './home/modals/Howtowin';
import PrizeSingleDisplayModeImage from './common/image/PrizeSingleDisplayModeImage'
import {prizeDisplayModeEnum} from '../constants/prizes'


export default {
  name: 'prizes',
  data() {
    return {
      componentModalAnswer: null,
      grandPrize: {},
      monthlyPrize: {},
      weeklyPrize: {},
      prize1: false,
      prize2: false,
      prize3: false,
      displayModeEnum: prizeDisplayModeEnum
    };
  },
  components: { Howtowin, PrizeCarousel, PrizeSingleDisplayModeImage },
  mounted() {
    // eslint-disable-next-line
    for (const [property] in this.getCarouselPrizes) {
      if (this.getCarouselPrizes[property].type === 'GRAND') {
        this.grandPrize = this.getCarouselPrizes[property];
        this.prize1 = true;
      } else if (this.getCarouselPrizes[property].type === 'MONTHLY') {
        this.monthlyPrize = this.getCarouselPrizes[property];
        this.prize2 = true;
      } else {
        this.weeklyPrize = this.getCarouselPrizes[property];
        this.prize3 = true;
      }
    }
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForSettings',
      'setHowItWinType',
    ]),
    translationPerQuantity(quantity) { // different method from translationPerType due to AR css
      return (quantity) > 1 ? this.getTranslations.visitor_prizes_winners_per : this.getTranslations.visitor_prizes_winner_per;
    },
    translationPerType(type) {
      if (type === this.prizeType.daily) return this.getTranslations.visitor_prizes_winners_per_day;
      if (type === this.prizeType.weekly) return this.getTranslations.visitor_prizes_winners_per_week;
      if (type === this.prizeType.monthly) return this.getTranslations.visitor_prizes_winners_per_month;
      return '';
    },
    openModal(i) {
      this.setHowItWinType(i);
      this.storeModalForSettings(Howtowin);
    },
  },
  computed: {
    ...mapState('common', [
      'modalForSettings',
      'prizeDisplayMode',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
    ...mapGetters('profile', [
      'getDailyPrize',
      'getWeeklyPrize',
      'getMonthlyPrize',
      'getCarouselPrizes',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Prizes.vue